import { useState, useRef, useEffect } from 'react';

import * as Sentry from '@sentry/react';

import { usePrizeBoxStore } from 'modules/prize-box-page/store/prize-box-store';

import SecondaryBtn from 'shared/components/ui/SecondaryBtn/SecondaryBtn';
import { OptimizedImage } from 'shared/components/ui/optimized-image/optimized-image';
import { useQuestsStore } from 'shared/store/questsStore';

import BurgerIcon from 'assets/burger.svg?react';
import attention from 'assets/png/!.png?format=webp;avif&as=picture';

import { Overlay } from './overlay';

export const BurgerMenu = () => {
  const [open, setOpen] = useState(false);
  const clickHandler = () => {
    setOpen(!open);
  };
  const sentryFeedbackRef = useRef<HTMLDivElement>(null);
  const { pointBalance, activeQuests } = useQuestsStore();
  const { attempts } = usePrizeBoxStore();
  useEffect(() => {
    const node = sentryFeedbackRef.current;
    if (!node) return;
    const feedback = Sentry.getFeedback?.();
    feedback?.attachTo(node, { formTitle: 'Tell us anything' });
  }, []);
  return (
    <div>
      <div className="relative">
        <SecondaryBtn
          onClick={clickHandler}
          svg={<BurgerIcon className="h-4 w-4 group-active:scale-90 sm:h-6 sm:w-6" />}
          className="min-h-9 min-w-9 rounded-lg sm:rounded-xl"
          childClassName="rounded-lg sm:rounded-xl sm:min-w-[52px] sm:min-h-[52px] min-h-9 py-1"
        />
        {Number(pointBalance) >= 100 || activeQuests > 0 || attempts > 0 ? (
          <OptimizedImage
            imageData={attention}
            alt="attention"
            className="absolute bottom-[-0.5rem] right-[-0.5rem] w-4 animate-badgePop motion-reduce:animate-none md:w-6"
          />
        ) : null}
      </div>

      <Overlay
        open={open}
        setOpen={setOpen}
        sentryFeedbackRef={sentryFeedbackRef}
        pointBalance={pointBalance}
        activeQuests={activeQuests}
      />
      <div ref={sentryFeedbackRef} onClick={() => setOpen(false)} />
    </div>
  );
};
